module.exports = __webpack_public_path__ + "static/img/product_images_22_h5_zh.36732a0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/product/product_images_22_h5_zh.png
// module id = anb9
// module chunks = 34